export default __webpack_public_path__ + "static/media/MetronomeFlash.77112281.wav";